//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import Table from '~/views/StatisticsReferralProgram/StatisticsReferralProgramData/Table.vue';
import referralProgramCharts from './StatisticsReferralProgramData/referralProgramCharts.vue';

export default {
  components: {
    Table,
    referralProgramCharts,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.load(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('statisticsReferralProgram', {
      load: 'loadData',
    }),
  },
};
